module.exports = __webpack_public_path__ + "img/img-jili-fish-d.da518229.png";